import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { ForgetPasswordAction, SetAuthLoading } from '../store/auth.actions';
import { AuthService } from '../services/auth.service';
import { SelectOption } from 'src/app/ui/form-field/form-field.component';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
  resetPasswordForm!: FormGroup;
  showDBOptions: boolean = false;
  databaseOptions: SelectOption[] = [];

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    localStorage.removeItem('currentUser');
    this.resetPasswordForm = this.fb.group({
      database: [''],
      email: ['', [Validators.required, Validators.email]]
    });

    this.showDBOptions = ['127.0.0.1', 'localhost', 'qa-', 'preprod'].filter(value => window.location.host.includes(value)).length > 0;
    this.getDBs();
  }

  requestPasswordReset(): boolean {
    if (!this.resetPasswordForm.valid) {
      this.resetPasswordForm.markAllAsTouched();
      return false;
    }
    this.store.dispatch(SetAuthLoading({ isLoading: true }));
    this.store.dispatch(ForgetPasswordAction({ payload: this.resetPasswordForm.value }));
    return true;
  }

  /**
   * `ui-form-field` calls `preventDefault()` on Enter, which also suppresses the
   * browser's implicit form submission — so submit explicitly. Scoped to inputs:
   * a button already turns Enter into a click, and letting this run there would
   * dispatch the request twice.
   */
  onEnterKey(event: Event): void {
    if ((event.target as HTMLElement | null)?.tagName === 'INPUT') {
      this.requestPasswordReset();
    }
  }

  getDBs(): void {
    this.authService.getDBs().subscribe((res) => {
      this.databaseOptions = (res.data ?? []).map((db: string) => ({ label: db, value: db }))
      this.resetPasswordForm.patchValue({ database: this.databaseOptions[0]?.value ?? '' })
    })
  }
}
